import { Route, Routes } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import NotFoundPage from '../pages/error/404'
import Dashboard from '../pages/Dashboard'
import Sidebar from '../components/menus/Sidebar'
import { useAuth } from '../components/auth/useAuth'
import Chatbot from '../pages/Chatbot'
import Topbar from '../components/menus/Topbar'
import Odoo from '../pages/Odoo'

export default function EmployeeRouter () {
	const { clientauth } = useAuth()
	const { t } = useTranslation()

	return (
		<Container fluid className='d-flex p-0'>
			<Sidebar rol={clientauth?.rol}/>
			<Container fluid className="p-0">
				<Topbar rol={clientauth?.rol} />

				<Routes>
					<Route path={`/${t('url.dashboard')}`} element={<Dashboard />} />
					<Route path={`/${t('url.chatbot')}`} element={<Chatbot />} />
					<Route path={`/${t('url.odoo')}`} element={<Odoo />} />

					<Route path="*" element={<NotFoundPage />} />
				</Routes>
			</Container>
		</Container>
	)
}